<template>
  <div
    class="p-2 font-bold ds-text-base rounded-full w-full text-center select-none cursor-pointer transition-all duration-200"
    :class="{
      'rounded-lg text-white': isActive,
      'bg-blue-300': isActive && secondTab,
      'bg-green-300': isActive && firstTab,
      'text-green-300': !isActive && secondTab,
      'text-blue-300': !isActive && firstTab,
      [`js-${id === 0 ? 'essentials': 'guidance'}-tab`]: true
    }"
    @click="$emit('click', id)"
  >
    {{ label }}
  </div>
</template>

<script>
export default {
  props: {
    label: { type: String, default: "" },
    isActive: { type: Boolean, default: false },
    id: { type: Number },
  },
  computed: {
    firstTab() {
      return this.id === 0
    },
    secondTab() {
      return this.id === 1
    }
  }
};
</script>

<style>
</style>